












































































import { defineComponent, ref } from '@vue/composition-api';
import { PropType } from 'vue';
import { BudgetSourceType, BudgetRecommendResponse, BudgetRecommendOptionItem } from '../types';
import { CurrencyOption } from './../../../../hooks/creation/account/useCurrencyOption/index';

const name = 'ttam-budget-recomment';

export default defineComponent({
  name,
  props: {
    data: {
      type: Object as PropType<BudgetRecommendResponse>,
      required: true,
      default: () => ({}),
    },
    options: {
      type: Array as PropType<BudgetRecommendOptionItem[]>,
      required: true,
      default: () => [],
    },
    currencyOption: {
      type: Object as PropType<CurrencyOption>,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    const isFold = ref(true);

    /** 展开推荐，是否调用这个方法，外部自己决定 */
    function expand() {
      isFold.value = false;
    }

    const apply = (budget: number, budgetSource: BudgetSourceType) => {
      emit('apply', budget, budgetSource);
    };

    return {
      name,
      BudgetSourceType,
      isFold,
      expand,
      apply,
    };
  },
});
